import React from "react";

export const LazyCreateProjectPage = React.lazy(
  () => import("modules/projectRole/pages/CreateProjectPage"),
);
